/**
 * Agent Portal - Listino Prezzi.
 * Wrapper che rende il componente pubblico Listino all'interno del layout agente
 * senza duplicare la logica (usa la prop hideChrome per nascondere Header/Footer).
 */
import React from 'react';
import AgentLayout from './AgentLayout';
import Listino from '../Listino';

const AgentListino = () => {
  return (
    <AgentLayout>
      <div data-testid="agent-strumenti-listino">
        <Listino hideChrome />
      </div>
    </AgentLayout>
  );
};

export default AgentListino;
